// @ts-nocheck -- removing type checking for now due to Ember Data mixin compatibility
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

import { apiAction } from '@mainmatter/ember-api-actions';

export default class Registration extends Model {
  @attr() status; // pending, contract_sign_pending, contract_sign_validation_error, completed
  @attr() partnerName;
  @attr() flowType;
  @attr() legalFlow;
  @attr() pricePlanCode;
  @attr() originalRecurrence;
  @attr('boolean') isPaid;
  @attr() discountPricePlanCodes;
  @attr('number') discountMonths;
  @attr() recommendedPricePlanCode;
  @attr() partnerType;
  @attr('boolean') companyCreationFromScratch;
  @attr('string') prepaidSource;

  @hasMany('stakeholder', { async: false, inverse: null }) stakeholders;
  @belongsTo('organization', { async: false, inverse: 'registration' }) organization;

  @cached
  get owner() {
    return this.stakeholders.find(({ owner }) => owner);
  }

  async submit() {
    return await apiAction(this, {
      method: 'POST',
      path: 'submit',
    });
  }

  get isEmbedded() {
    return this.partnerType === 'embed';
  }

  get isLegalPlace() {
    return this.partnerName?.toLowerCase() === 'legalplace';
  }

  /**
   * For French Full Company Creation flow
   * @returns {boolean}
   */
  get isFrFullCompanyCreation() {
    return this.organization.get('legalCountry') === 'FR' && this.legalFlow === 'company_creation';
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    registration: Registration;
  }
}
